import { ActionSubTypes } from '../../../../actions/ActionSubTypes';
import ApiBaseReducer from '../../../core/ApiBaseReducer';
import pList from '../../../../api/models/pList';
import { DefaultInputDataStateModel, IInputDataStateModel } from '../../../../models/StateModels';
import { rOyakDegerlemeUstBilgi } from '../../../../api/models/rOyakDegerlemeUstBilgi';

export default ApiBaseReducer<
  pList,
  IInputDataStateModel<pList, rOyakDegerlemeUstBilgi>,
  rOyakDegerlemeUstBilgi
>(
  ActionSubTypes.API_OYAKDEGERLEMEUSTBILGI,
  DefaultInputDataStateModel<pList, rOyakDegerlemeUstBilgi>()
);
